<div *ngIf="!countertops?.length" class="text-base text-gray-400 text-center p-5 w-full" i18n
  >Столешницы не добавлены</div
>
<mat-list class="h-full overflow-scroll">
  <ng-container *ngFor="let item of countertops">
    <mat-list-item [ngClass]="{ 'cursor-pointer': mode === 'view' }" (click)="mode === 'view' && editItem.emit(item)">
      <div mat-line>{{ item.material.name }} {{ item.material.article }}</div>
      <div mat-line class="secondary-text">{{ item.length }}×{{ item.width }}</div>
      <ng-container *ngIf="mode === 'edit'">
        <button mat-icon-button *ngIf="item.has3d" class="ml-2" (click)="openModelViewer(item)">
          <mat-icon>3d_rotation</mat-icon>
        </button>
        <button mat-icon-button (click)="editItem.emit(item)" [disabled]="disabled(item)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="deleteItem.emit(item)" [disabled]="disabled(item)">
          <mat-icon>delete</mat-icon>
        </button>
      </ng-container>
    </mat-list-item>
  </ng-container>
</mat-list>
